import React from 'react';
import { Check } from 'lucide-react';

// Unified signup consent: mandatory 18+ / Terms checkbox + privacy/cookie info line.
export const SignupTermsCheckbox = ({ checked, onChange, testId = 'signup-terms-checkbox' }) => (
  <div className="space-y-2" data-testid={`${testId}-block`}>
    <label className="flex items-start gap-3 cursor-pointer group">
      <div className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors ${checked ? 'bg-[#F5A623] border-[#F5A623]' : 'border-gray-600 group-hover:border-gray-500'}`}>
        {checked && <Check className="w-3 h-3 text-[#1A1A1A]" />}
      </div>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="hidden" data-testid={testId} />
      <span className="text-sm text-gray-300">
        Confermo di avere almeno <strong className="text-white">18 anni</strong> e accetto i{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className="text-[#F5A623] underline" data-testid={`${testId}-terms-link`}>Termini di servizio</a>
        <span className="text-red-400"> *</span>
      </span>
    </label>
    <p className="text-[11px] text-gray-500 pl-8 leading-relaxed" data-testid={`${testId}-privacy-info`}>
      Come trattiamo i tuoi dati:{' '}
      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#F5A623] underline">Informativa privacy</a>
      {' '}e{' '}
      <a href="/cookie-policy" target="_blank" rel="noopener noreferrer" className="text-[#F5A623] underline">Cookie policy</a>
    </p>
  </div>
);

export default SignupTermsCheckbox;
